import { render, staticRenderFns } from "./PharmacyOrder.vue?vue&type=template&id=6b0c27ae&scoped=true"
import script from "./PharmacyOrder.vue?vue&type=script&lang=js"
export * from "./PharmacyOrder.vue?vue&type=script&lang=js"
import style0 from "./PharmacyOrder.vue?vue&type=style&index=0&id=6b0c27ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c27ae",
  null
  
)

export default component.exports